
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt",
      function () {
        return require("private-next-pages/egypt/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt"])
      });
    }
  